<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header print-hide">
      <div class="col-sm-12 d-flex justify-content-between align-items-center">
        <h6 class="modal-title title" i18n>Print Booking Preview</h6>
        <div class="btn-holder">
          <button (click)="onPrint()" type="button" class="btn btn-secondary-secondary ml-2">
            <span class="fal fa-print" aria-hidden="true"></span> <ng-container i18n>Print</ng-container>
          </button>
        </div>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body" id="booking-print-preview">
      <div class="mainbody" #preview>
        <table class="content-box" cellpadding="0" cellspacing="0">
          <tr>
            <td class="sidebar">
              <h2 class="title" i18n>Guest Details</h2>
              <table cellpadding="0" cellspacing="0">
                <tr>
                  <td>
                    <ng-container i18n>Name</ng-container><br />
                    <strong> {{ inquiry?.guest?.name || '-' }}&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ng-container i18n>Telephone</ng-container><br />
                    <strong> {{ inquiry?.guest?.phone || '-' }}&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ng-container i18n>Email</ng-container><br />
                    <strong> {{ inquiry?.guest?.primaryEmail || '-' }}&nbsp; </strong>
                  </td>
                </tr>
              </table>

              <h2 class="title" i18n>Booking Details</h2>
              <table cellpadding="0" cellspacing="0">
                <tr>
                  <td colspan="2">
                    <ng-container i18n>Rentals</ng-container><br />
                    <strong> {{ inquiry?.rentalView }}&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ng-container i18n>Adults</ng-container>:<br />
                    <strong> {{ inquiry?.numAdults }}&nbsp; </strong>
                  </td>
                  <td>
                    <ng-container i18n>Children</ng-container>:<br />
                    <strong> {{ inquiry?.numChild }}&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ng-container i18n>From</ng-container>:<br />
                    <strong> {{ inquiry?.arriveView }}&nbsp; </strong>
                  </td>
                  <td>
                    <ng-container i18n>To</ng-container>:<br />
                    <strong> {{ inquiry?.departView }}&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ng-container i18n>Stay</ng-container><br />
                    <strong>
                      {{ inquiry?.nightsView + 1 }} <ng-container i18n>Days</ng-container>, {{ inquiry?.nightsView }}
                      <ng-container i18n>Nights</ng-container>
                    </strong>
                  </td>
                  <td>
                    <ng-container i18n>Timezone</ng-container><br />
                    <strong> {{ (checkInOut$ | async).timezone || '-' }}&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ng-container i18n>Check-In</ng-container>:<br />
                    <strong> {{ (checkInOut$ | async).checkIn | epoch : 'h:mm A' }}&nbsp; </strong>
                  </td>
                  <td>
                    <ng-container i18n>Check-Out</ng-container>:<br />
                    <strong> {{ (checkInOut$ | async).checkOut | epoch : 'h:mm A' }}&nbsp; </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ng-container i18n>Source</ng-container>:<br />
                    <strong> {{ inquiry?.inquirySource || '-' }}&nbsp; </strong>
                  </td>
                </tr>
              </table>

              <h2 class="title" i18n>Booking Charges</h2>
              <ng-container *ngIf="external || !inquiry?.bookingEngine">
                <table cellpadding="0" cellspacing="0" *ngIf="bookingCharge$ | async; let bookingCharge">
                  <tr>
                    <td>
                      <ng-container i18n>Base Charge</ng-container>:<br />
                      <strong> {{ bookingCharge.charge | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ng-container i18n>Additional Guests Fee</ng-container>:<br />
                      <strong> {{ bookingCharge?.extraGuests || 0 | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ng-container i18n>Discounts & Fees</ng-container>:<br />
                      <strong>
                        {{
                          (bookingCharge?.discountSum || 0) + (bookingCharge?.feeSum || 0) | tokeetCurrency : currency
                        }}&nbsp;
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ng-container i18n>Taxes</ng-container>:<br />
                      <strong> {{ bookingCharge?.taxFee || 0 | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr *ngIf="formulaAdjustedCost | async as formulaCost">
                    <td>
                      <ng-container i18n>Booking Formula</ng-container>:<br />
                      <strong> {{ formulaCost | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong i18n>Total</strong><br />
                      <strong style="color: #d44a48; font-size: 16px">
                        {{ bookingCharge?.sum | tokeetCurrency : currency }}&nbsp;
                      </strong>
                    </td>
                  </tr>
                </table>
              </ng-container>
              <ng-container *ngIf="!external && !!inquiry?.bookingEngine">
                <table cellpadding="0" cellspacing="0" *ngIf="inquiry?.bookingEngine as bookingEngine">
                  <tr>
                    <td>
                      <ng-container i18n>Base Charge</ng-container>:<br />
                      <strong> {{ bookingEngine.extraBedroomsBase | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ng-container i18n>Additional Guests Fee</ng-container>:<br />
                      <strong> {{ bookingEngine?.extraGuests || 0 | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr *ngIf="!!bookingEngine?.extraBedrooms">
                    <td>
                      <ng-container i18n>Additional Bedrooms Fee</ng-container>:<br />
                      <strong> {{ bookingEngine?.extraBedrooms || 0 | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ng-container i18n>Discounts & Fees</ng-container>:<br />
                      <strong> {{ bookingEngine?.discountTotal | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr *ngFor="let fee of bookingEngine?.bookingFees">
                    <td>
                      {{ fee.name }}:<br />
                      <strong> {{ fee.amount | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ng-container i18n>Taxes</ng-container>:<br />
                      <strong> {{ bookingEngine?.taxTotal || 0 | tokeetCurrency : currency }}&nbsp; </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong i18n>Total</strong><br />
                      <strong style="color: #d44a48; font-size: 16px">
                        {{ bookingEngine?.total | tokeetCurrency : currency }}&nbsp;
                      </strong>
                    </td>
                  </tr>
                </table>
              </ng-container>
            </td>
            <td class="content-holder">
              <table class="box-holder" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="100%">
                    <table class="invoice-table-holder" cellpadding="0" cellspacing="0">
                      <tr>
                        <td>
                          <h2 class="title mx-2" i18n>Invoices</h2>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table class="simple-table table table-striped" cellpadding="0" cellspacing="0">
                            <thead>
                              <tr>
                                <th i18n>Invoice #</th>
                                <th i18n>Invoice Date</th>
                                <th i18n>Due Date</th>
                                <th i18n>Status</th>
                                <th i18n>Amount Due</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let invoice of invoices">
                                <td>
                                  <strong>{{ invoice.invoiceNum }}</strong>
                                </td>
                                <td>{{ invoice.invoiceDate | epoch : 'DD - MMM - YYYY' }}</td>
                                <td>{{ invoice.dueDate | epoch : 'DD - MMM - YYYY' }}</td>
                                <td>{{ invoice.status | invoiceStatus }}</td>
                                <td>
                                  <app-invoice-total [invoice]="invoice"></app-invoice-total>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h2 class="title mx-2" i18n>Flights Detail</h2>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table class="simple-table table table-striped" cellpadding="0" cellspacing="0">
                            <thead>
                              <tr>
                                <th i18n>Flight No.</th>
                                <th i18n>Airline</th>
                                <th i18n>Departure</th>
                                <th i18n>Arrival</th>
                                <th i18n>Timezone</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let flight of flights$ | async">
                                <td>
                                  <strong>{{ flight.flightNum }}</strong>
                                </td>
                                <td>{{ flight.airline | airlineCode }}</td>
                                <td>{{ flight.departure | epochUTC : 'datetime' }}</td>
                                <td>{{ flight.arrival | epochUTC : 'datetime' }}</td>
                                <td>{{ flight.timezone }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h2 class="title mx-2" i18n>Notes</h2>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table class="simple-table table table-striped" cellpadding="0" cellspacing="0">
                            <thead>
                              <tr>
                                <th i18n>Date Added</th>
                                <th i18n>User</th>
                                <th width="60%" style="text-align: left" i18n>Note</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let note of inquiry?.notes">
                                <td>{{ note.timestamp | epoch }}</td>
                                <td>{{ note.user }}</td>
                                <td width="60%" style="text-align: left">{{ note.note }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
